import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// 是否在提示错误信息
		errorMsgFlag: false,

		// 显示重量单位
		showUnitType: '',

		// 域名
		host: '',

		// token
		token: '',

		// 权限列表数据
		permissionListDatas: [],


		// 平台logo
		logo: '',

		// 主题颜色
		mainColor: '',
		// 结算按钮字体色
		fontColor: '',
		// 结算按钮背景色
		bgColor: '',



	},
	mutations: {
		// 给 state 设置数据
		setStateDataFn(store, data) {
			Object.keys(data).forEach(key => store[key] = data[key]);
		},
	},
	actions: {},
	getters: {},
	modules: {},
})


// WEBPACK FOOTER //
// ./src/store/index.js